import { render, staticRenderFns } from "./IconDotsHorizontalSolid.vue?vue&type=template&id=3bd3be9e"
import script from "./IconDotsHorizontalSolid.vue?vue&type=script&lang=js"
export * from "./IconDotsHorizontalSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports